import { request, uploadRequest } from "./request";

export function listProjectsWithDevices() {
  return request("/device/listProjectsWithDevices", {
    method: "GET",
  });
}

export function listAllDevices() {
  return request("/device/listAllDevices", {
    method: "GET",
  });
}

export function addProjects(data) {
  return request("/device/addProjects", {
    method: "POST",
    body: {
      code: data.code,
      name: data.name,
      serviceDescribe: data.serviceDescribe ?? data.describe,
      duration: data.duration,
      isFieldRequired: Number(data.isFieldRequired) === 1 ? 1 : 0,
      deviceIds: (data.deviceIds || []).map((id) => String(id)),
      repairIds: (data.repairIds || []).map((id) => String(id)),
    },
  });
}

export function getProject(data) {
  return request("/device/getProject", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
    },
  });
}

export function updateProject(data) {
  return request("/device/updateProject", {
    method: "POST",
    body: {
      id: String(data.id),
      code: data.code,
      name: data.name,
      duration: data.duration,
      serviceDescribe: data.serviceDescribe ?? data.describe,
      isFieldRequired: Number(data.isFieldRequired) === 1 ? 1 : 0,
      checkedDevices: (data.checkedDevices || []).map((d) => ({
        deviceId: String(d.deviceId),
        deviceName: d.deviceName,
      })),
      repairIds: (data.repairIds || []).map((id) => String(id)),
    },
  });
}

/** 上传服务项目图片 POST /device/uploadProjectImage */
export function uploadProjectImage(data) {
  const formData = new FormData();
  formData.append("file", data.file);
  formData.append("projectId", String(data.projectId));
  return uploadRequest("/device/uploadProjectImage", formData);
}

/** 查询服务项目图片 POST /device/getProjectImage */
export function getProjectImage(data) {
  return request("/device/getProjectImage", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
    },
  });
}

/** 删除服务项目图片 POST /device/deleteProjectImage */
export function deleteProjectImage(data) {
  return request("/device/deleteProjectImage", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
      imageId: data.imageId != null ? String(data.imageId) : "",
    },
  });
}

export function addDevices(data) {
  return request("/device/addDevices", {
    method: "POST",
    body: {
      deviceName: data.deviceName,
    },
  });
}

export function saveCheckedDevices(data) {
  return request("/device/saveCheckedDevices", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
      deviceIds: data.deviceIds || [],
    },
  });
}

export function deleteProject(data) {
  return request("/device/deleteProject", {
    method: "POST",
    body: {
      projectId: String(data.projectId),
    },
  });
}

export function updateDevice(data) {
  return request("/device/updateDevice", {
    method: "POST",
    body: {
      deviceId: String(data.deviceId),
      deviceName: data.deviceName,
    },
  });
}

export function deleteDevice(data) {
  return request("/device/deleteDevice", {
    method: "POST",
    body: {
      deviceId: String(data.deviceId),
    },
  });
}
